"use client";

import { CandidateCardsIcon } from "@/components/icons/common";
import {
  AppWindow,
  Bell,
  Calendar,
  ChevronsLeftRightEllipsis,
  CreditCard,
  Megaphone,
  NotepadText,
  Users,
} from "lucide-react";

const MARQUEE_ITEMS = [
  { label: "Calendar", icon: Calendar },
  { label: "Invoicing", icon: CreditCard },
  { label: "Clients", icon: CandidateCardsIcon },
  { label: "Automated Messages", icon: Bell },
  { label: "Booking Website", icon: AppWindow },
  { label: "Marketing", icon: Megaphone },
  { label: "Free Data Transfer", icon: ChevronsLeftRightEllipsis },
  { label: "Team Management", icon: Users },
  { label: "Rebooking Reminders", icon: Bell },
  { label: "Inventory", icon: NotepadText },
];
export function FeaturesStripe() {
  return (
    <div className="relative py-18 overflow-x-hidden">
      {/* Product preview mosaic substitute */}
      <div className="absolute start-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2">
        <div className="group gap-(--marquee-gap) overflow-hidden p-3 flex-row  flex w-full items-center font-medium sm:p-3 sm:text-lg">
          {[1, 2, 3].map((loop) => (
            <div
              key={loop}
              className="flex shrink-0 justify-around gap-(--marquee-gap) animate-marquee-horizontal flex-row group-hover:[animation-play-state:paused] [animation-delay:var(--marquee-delay)]"
            >
              {MARQUEE_ITEMS.map(({ label, icon: Icon }, idx) => (
                <div
                  key={idx}
                  className="flex  relative p-2 pr-5 overflow-hidden rounded-xl gap-3 items-center"
                >
                  <div className="absolute bg-white/70 left-0 backdrop-blur-xl right-0 w-full h-full rounded-xl"></div>
                  <span className="p-2 bg-fe-primary/20 border border-neutral-500 backdrop-blur-xl rounded-md ">
                    <Icon className="size-6 text-neutral-900 sm:size-7 [&>*]:stroke-[1.3] " />
                  </span>
                  <span className="text-xl text-neutral-800 z-10">{label}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
